import React from "react";
import { Route, Switch } from "react-router-dom";
import { Dashboard } from "../pages/Application";
import AppDrawer from "../components/Layout/AppDrawer";
import LiveScreen from "pages/Application/liveScreen";
import Tasks from "pages/Application/tasks";
import Logbooks from "pages/Application/logbooks";
import Guards from "pages/Application/guards";
import Reports from "pages/Application/reports";
import ShiftPlayback from "pages/Application/shiftPlayback";
import Roles from "pages/Application/roles";
import PointsOfInterest from "pages/Application/pointsOfInterest";
import BuildingRoute from "./BuildingRoute";
import Zones from "pages/Application/BuildingConfig/zones";
import {
  PatrolsData,
  IncidentsData,
  ShiftsData,
  ShiftsDataGrid,
  TasksData,
} from "pages/Application/Data";
export const ApplicationRoutes = () => {
  return (
    <AppDrawer>
      <Switch>
        <Route exact path="/app/dashboard" component={Dashboard} />
        <BuildingRoute exact path="/app/livescreen" component={LiveScreen} />
        <BuildingRoute exact path="/app/tasks" component={Tasks} />
        <BuildingRoute exact path="/app/users" component={Guards} />
        <BuildingRoute exact path="/app/reports" component={Reports} />
        <BuildingRoute
          exact
          path="/app/shift_playback"
          component={ShiftPlayback}
        />
        <BuildingRoute exact path="/app/data/patrols" component={PatrolsData} />
        <BuildingRoute
          exact
          path="/app/data/incidents"
          component={IncidentsData}
        />
        <BuildingRoute exact path="/app/data/shifts" component={ShiftsData} />
        <BuildingRoute
          exact
          path="/app/data/shifts_grid"
          component={ShiftsDataGrid}
        />
        <BuildingRoute exact path="/app/data/tasks" component={TasksData} />
        <BuildingRoute exact path="/app/roles" component={Roles} />
        <BuildingRoute exact path="/app/logbooks" component={Logbooks} />
        <BuildingRoute
          exact
          path="/app/building/pois"
          component={PointsOfInterest}
        />
        <BuildingRoute exact path="/app/building/zones" component={Zones} />
      </Switch>
    </AppDrawer>
  );
};
